import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { formatAmountCurrency } from '../../../../../../../utils';

import { white, lightGrey, secondary } from '../../../../../../../scss/_variables.scss';

const View = styled.div`
    display: flex;
    align-items: center;
`;

const ButtonAddMore = styled.button`
    border: none;
    color: ${secondary};
    background-color: ${white};
    font-size: 12px;
    flex: 1;
    outline: none;
    padding: 0;
    cursor: pointer;
`;
const DivBasketRowItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px;

    p {
        margin: 0;
    }
`;
const DivButton = styled.div`
    display: flex;
    border: 1px solid ${secondary};
    width: 65px;
    height: 20px;
    align-items: center;

    p {
        margin: 0;
        padding: 0 5px;
        border-right: 1px solid ${lightGrey};
        border-left: 1px solid ${lightGrey};
        height: 100%;
        flex: 1;
        text-align: center;
        font-weight: bold;
        font-size: 12px;
    }
`;
const Amount = styled.span`
    font-weight: bold;
    min-width: 47px;
    margin-left: 10px;
    text-align: right;
`;

const BasketRowItem = ({ ebon, amount, handleItemChange, text, isBasketLimitReached }) => {
    const handleMore = () => {
        if (ebon.quantityQuery < ebon.quantityAvailable && !isBasketLimitReached) {
            const newQuantity = ebon.quantityQuery + 1;
            handleItemChange(newQuantity, ebon);
        }
    };
    const handleLess = () => {
        if (ebon.quantityQuery > 0) {
            const newQuantity = ebon.quantityQuery - 1;
            handleItemChange(newQuantity, ebon);
        }
    };
    return (
        <DivBasketRowItem>
            <p>
                {text} : {formatAmountCurrency(ebon.facialValue)}
            </p>
            <View>
                <DivButton>
                    <ButtonAddMore disabled={amount <= 0} onClick={() => handleLess()}>
                        -
                    </ButtonAddMore>
                    <p>{ebon.quantityQuery}</p>
                    <ButtonAddMore
                        onClick={() => handleMore()}
                        disabled={
                            ebon.quantityQuery >= ebon.quantityAvailable || isBasketLimitReached
                        }>
                        +
                    </ButtonAddMore>
                </DivButton>
                <Amount>{formatAmountCurrency(amount)}</Amount>
            </View>
        </DivBasketRowItem>
    );
};

BasketRowItem.propTypes = {
    ebon: PropTypes.object.isRequired,
    amount: PropTypes.number.isRequired,
    handleItemChange: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
};

export default BasketRowItem;



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/payment-requests/ebon/ebonselector/BasketRowItem.js